const o=()=>window.navigator.userAgent.toLowerCase().includes("android");export{o as isAndroidDevice};
